// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> reserves-at-arlington
// Generated: 2026-11-02T16:59:42.227Z
// Counts: 5 design, 68 content, 61 slot group, 1 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Your Dream Life at Our Charming Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Reserves at Arlington has everything you need in your next home! We have spacious 1-2 bedroom apartments at the best prices in the area. These units include an open and fully equipped kitchen with a breakfast bar, ample closet space, large windows for natural light, and plush wall-to-wall carpeting. Enjoy fantastic community offerings including a shimmering pool, organized activities, outside picnic areas, on-site laundry, and abundant off-street parking. Our buildings boast locked entries and package services, and you can enjoy easy living with our automated rental payment program. We also offer short-term leasing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your lifestyle at Reserves at Arlington, where modern comforts meet nature's beauty in Columbus, OH. Enjoy spacious one and two-bedroom <a href=\"/floor-plans\">floor plans</a>, high-speed internet, and inviting grilling stations. Dive into a community that embraces pets, offers flex rent payments, and ensures your peace of mind with 24-hour emergency maintenance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience modern living at Reserves at Arlington in Columbus, OH. Choose from thoughtfully designed one- and two-bedroom floor plans with stylish amenities, including pet-friendly spaces, scenic walking trails, and sleek kitchens with stainless steel appliances. Embrace comfort and convenience—your ideal home awaits, just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Arlington in Columbus, OH, we offer thoughtfully designed one and two-bedroom apartments tailored for your lifestyle. Each floor plan boasts stylish spaces and modern amenities to elevate your living experience. Browse our available options and find the perfect home to fit your unique needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Arlington, vibrant living meets serene spaces in Columbus, OH. Picture yourself unwinding in our pet-friendly community, complete with walking trails, upgraded kitchens featuring stainless steel appliances, and inviting courtyards. Experience comfort and convenience with flexible rent options and 24-hour maintenance. Your dream home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Reserves at Arlington",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Arlington in Columbus, OH, find your ideal living space with one and two-bedroom floor plans. Enjoy scenic walking trails, modern amenities, and pet-friendly options. With upgraded kitchens and inviting community features like a swimming pool and grilling stations, your perfect retreat awaits—schedule a tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to the Reserves at Arlington, where convenience meets comfort in Columbus, OH. Enjoy access to top-rated schools, serene parks, and vibrant cultural destinations like the Wexner Center for the Arts and the Columbus Museum of Art. Your perfect home awaits amidst a lively community brimming with local favorites!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Arlington in Columbus, OH, our variety of thoughtfully designed one and two-bedroom floor plans offer the perfect canvas for your lifestyle. Access your resident portal today for convenient online rent payments, hassle-free maintenance scheduling, and more—your seamless living experience awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Reserves at Arlington in Columbus, OH, you'll find thoughtfully designed one and two-bedroom apartments that cater to your lifestyle. Each space blends comfort and style, perfect for making lasting memories. Schedule a tour today and hear firsthand from our residents why they love calling this community home!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out to Reserves at Arlington in Columbus, OH! Whether you’re drawn to our cozy one-bedroom retreat or spacious two-bedroom haven, we offer floor plans designed to fit your lifestyle. A team member will be in touch soon to help you find your perfect home!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Arlington in Columbus, OH, choose from thoughtfully designed one and two-bedroom apartments tailored to your lifestyle. Experience modern living with spacious floor plans and elegant finishes. Ready to see your new home? Take a virtual tour today and feel the vibrant community atmosphere!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-bcfa-72d4-9ddb-66bcfe246c91.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright bedroom with a bed, wall art, open closet, and carpeted floor at the Reserves at Arlington in Columbus, OH."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-fa30-7722-858b-fbd7156e9b4c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "clubhouse kitchen with granite island, three pendant lights, and bar stools in a bright open layout"
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-3777-7719-9b4a-5702864b6797.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open kitchen with a stone-front island, sink, and metal pendant lights."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166341/019d026a-3777-7719-9b4a-5702864b6797.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with a stone-accented breakfast bar and stainless steel stools."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-1fc3-76c5-8224-24b0aa79dcd0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright apartment living room with beige sofa, round glass coffee table, TV stand, plant, and wall art."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-6786-7459-b76d-1f975c672be5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with granite countertops, stainless steel fridge, stove, and dishwasher."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-5b16-73df-9d7e-f9407b8aa925.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment living room with a gray sofa, white armchair, plant, and a large window."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-0a04-7794-9c14-bd5ba3a2d387.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment kitchen with beige cabinets, white countertops, a mosaic tile backsplash, and stainless steel appliances."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166341/019d026a-5714-762c-a304-ea37ba30e53b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings and surrounding neighborhood with trees and roads."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166341/019d026a-5714-762c-a304-ea37ba30e53b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings and surrounding neighborhood with trees and roads."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-5714-762c-a304-ea37ba30e53b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a large apartment community with multiple buildings, parking lots, and surrounding streets."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-4c2a-700a-b256-58e5fcdf4db8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman in athletic wear holds a small brown poodle-like dog in a sunlit park."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-ee53-7244-9f17-99b24b3ab3e0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Courtyard swimming pool with blue water, lounge chairs, and apartment buildings under a red umbrella."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-42a0-71bb-854e-0bb531b5a0ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community pool with white lounge chairs and a blue umbrella, building in background."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166341/019d026c-75c0-747c-a13b-1f6183508538.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment including a tunnel and jump hoops."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-7431-7148-a372-5cfabfebd70a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor communal patio with beige sectional sofa, brick walls, and string lights."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "2 Months' Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pest": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pest Control"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "350"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.storage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Storage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$15"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-1fc3-76c5-8224-24b0aa79dcd0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright apartment living room with beige sofa, round glass coffee table, TV stand, plant, and wall art."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-3777-7719-9b4a-5702864b6797.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open kitchen with a stone-front island, sink, and metal pendant lights."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026c-7431-7148-a372-5cfabfebd70a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor communal patio with beige sectional sofa, brick walls, and string lights."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-0a19-7048-bf42-ee154e3094df.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a wooden table and six chairs under a chandelier."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8714-7508-8900-48ec73be9d26.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Belle's Bread Japanese Bakery and Café"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Bakery"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Pastries, custom cakes & other desserts, plus a cafe menu, offered in a cheery space with seating."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-00f5-77bc-a897-49b85b426258.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Polaris Fashion Place"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Chain retailers & specialty shops in a modern mall with kiddie events, play areas & a food court."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-dfe9-7260-92e0-845155d06e51.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Reed Road Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "City park with a playground, picnic areas, volleyball and tennis courts, and a pool."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8718-7310-ae06-43a602b51f89.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Akai Hana"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A simple, understated setting for Japanese & Korean cuisine backed by beer, wine, soju & sake."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c906-72ed-84fe-cac7ad8847db.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Columbus Museum of Art"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Varied permanent & traveling art collections plus an American cafe & a gift shop."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-e0ab-733c-8adb-ad8e7ed628e6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Thompson Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Recreation"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local complex featuring athletic fields, paved trails, a playground & a hill for sledding."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9d80-74ff-8756-f156261597fb.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Kelley's Pub & Patio"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Laid-back neighborhood bar and eatery featuring a menu of Cajun classics, plus burgers and steaks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-cda0-7202-ba87-6b1f947a49a4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Palace Theatre"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Performance venue hosting theatrical as well as classical, dance & world music productions."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-8e10-70b8-9f65-24971e589fde.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sushi Ten"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Market-based sushi spot with an extensive menu of raw fish & rolls plus poke, edamame & miso soup."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026b-05a4-7234-b78b-afa03b03fd35.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Topgolf Columbus"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Lounge & Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-c029-735f-91e2-020be88cf712.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Grandview Theater and Drafthouse"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "This 1926 single-screen theater sells beer as well as pizza, subs & pastries from local restaurants."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019d026a-9595-749f-9e60-edf40dce3181.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "HoneyDip Donuts & Diner"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Diner-like shop offering coffee and breakfast standards such as omelets and corned beef hash, plus donuts."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b16e-7399-aba9-28055a1f2e6b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92c-b143-77ef-b401-bf89a8a00466.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166341/019fd92d-0775-73d6-a91b-1f293fabece3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
